import { Injectable } from '@angular/core'
import { AccountwithCustomer, ApiCatalogService } from '../api/api-catalog.service'
// import { AuthService } from '../components/isbeauth/auth.service'

@Injectable({
  providedIn: 'root',
})
export class AccountRegistrationService {
  private registrationData: AccountwithCustomer | null = null
  private accountType: 'admin' | 'user' | null = null

  constructor(
    private apiCatalogService: ApiCatalogService,
    // private authService: AuthService,
  ) {}

  setAccountType(type: 'admin' | 'user' | null): void {
    this.accountType = type
  }

  getAccountType(): 'admin' | 'user' | null {
    return this.accountType
  }

  setRegistrationData(data: AccountwithCustomer): void {
    this.registrationData = data
  }

  getRegistrationData(): AccountwithCustomer | null {
    return this.registrationData
  }

  clearRegistrationData(): void {
    this.registrationData = null
  }

  async registerWithTerms(value: any): Promise<boolean> {
    const customerInfo = this.getRegistrationData()
    if (!customerInfo) return false

    try {
      // 顧客登録
      const ret = await this.apiCatalogService.CreateAccountWithCustomer(customerInfo)
      const accountId = ret?.accountId
      if (!accountId) {
        return false
      }

      //accountId、customerIdがセットされた情報をセット
      this.setRegistrationData(ret)

      // 自動ログイン用
      // this.authService.setAutoLoginAccountId(accountId)

      // 証跡保存
      const contractTypeId = 'termOfAccountCreation'
      const model = {
        consentMethod: 'checkbox',
        legalId: value.legalId,
        userAgent: navigator.userAgent,
      }

      const tosRet = await this.apiCatalogService.postConfirmToS(contractTypeId, accountId, model)
      if (tosRet === undefined) {
        return false
      }

      return true
    } catch (error) {
      return false
    }
  }
}
